/**
 * Conteúdo institucional e navegação — fonte única para navbar, footer, SEO e formulários.
 */

export const site = {
  name: "Alert AI",
  legalName: "2M Connections Ltda.",
  url: "https://alertai.com.br",
  slogan: "Segurança inteligente integrada ao seu mundo.",
  concept: "Mais do que ver, Alert AI entende. E reage.",
  title: "Alert AI | Segurança inteligente integrada ao seu mundo",
  description:
    "Inteligência artificial para segurança, monitoramento, controle de acesso e análise em tempo real. Conheça as soluções Alert AI para Sports, Education, Retail e Traffic.",
  email: "contato@alertai.com.br",
  whatsapp: "5555996125767",
  // Endereço conforme a Política de Privacidade do AlertAI Education
  address: {
    street: "R. Eulália Oliveira Irion, 302, sala 01 — Dom Antônio Reis",
    city: "Santa Maria",
    region: "RS",
    postalCode: "97065-170",
    country: "BR",
  },
  loginUrl: "https://alertai.com.br/app/authentication/signIn",
  products: {
    sports: "https://alertai.com.br/sports",
    education: "https://education.alertai.com.br/",
  },
  privacyUrl: "/alertAI-educationPolitically",
} as const;

export const downloads = [
  {
    id: "setup",
    label: "AlertAI Setup",
    hint: "Instalador da plataforma",
    href: "https://alertai.com.br/api/v1/downloads/AlertAiSetup.zip",
  },
  {
    id: "auto-register",
    label: "Auto Register",
    hint: "Configurador de cadastro automático",
    href: "https://alertai.com.br/api/v1/downloads/AlertAiAutoRegisterConfigurator.zip",
  },
] as const;

export const navLinks = [
  { label: "Soluções", href: "/#tecnologia", id: "tecnologia" },
  { label: "Parceiros", href: "/#parceiros", id: "parceiros" },
  { label: "Contato", href: "/#contato", id: "contato" },
] as const;

// Retail e Traffic ainda não têm página/produto publicado para linkar.
export const solutionLinks = [
  { label: "Sports", href: site.products.sports },
  { label: "Education", href: site.products.education },
] as const;

export const footerColumns = [
  {
    title: "Soluções",
    links: solutionLinks,
  },
  {
    title: "Empresa",
    links: [
      { label: "Parceiros", href: "/alertAI-partners" },
      { label: "Contato", href: "/#contato" },
      { label: "Suporte", href: "/alertAI-contact" },
    ],
  },
  {
    title: "Recursos",
    links: [
      {
        label: "Download · AlertAI Setup",
        href: downloads[0].href,
        track: "download",
        trackLabel: "footer-setup",
      },
      {
        label: "Download · Auto Register",
        href: downloads[1].href,
        track: "download",
        trackLabel: "footer-auto-register",
      },
      { label: "Área do cliente", href: site.loginUrl },
      { label: "Privacidade e LGPD", href: site.privacyUrl },
      // "Termos de Uso": ainda não existe página publicada. Adicionar aqui
      // quando o texto jurídico estiver disponível (não criamos conteúdo legal).
    ],
  },
] as const;
